/**
 * @ngdoc directive
 * @name input[file]
 *
 * @description
 * Add ng-model and base64 support to input[file] :
 */
module.directive('input', function() {
    'use strict';
    return {
        restrict: 'E',
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
            if (ngModel && attrs['type'] === 'file') {
                element.on('change', function() {
                    var files = [];
                    for (var i = 0, count = element[0].files.length; i < count; ++i) {
                        files.push(element[0].files[i]);
                    }
                    var ngModelValue = [];

                    function readFiles(files) {
                        if (files.length > 0) {
                            var file = files.shift();
                            var reader = new FileReader();
                            reader.readAsDataURL(file);

                            reader.onload = function () {
                                    ngModelValue.push({
                                    filename: file.name,
                                    filemime: file.type,
                                    size: file.size,
                                    data: reader.result.split(',')[1]
                                });
                                readFiles(files);
                            };
                        } else {
                            ngModel.$setViewValue(ngModelValue);
                        }
                    }

                    readFiles(files);
                });
            }
        }
    }
});
